import React from "react";
import "./PricingMode.scss";
import { billingDollar } from "assets/icons";
import { LoadingButton } from "components/form";
import FAQS from "components/faqs/FAQS";

const plans = [
  {
    name: "Basic",
    price: 0,
    description: ["100 responses/mo.", "10 questions/survey", "Basic template"],
    amount: 0,
    iconCount: 2,
  },
  {
    name: "Pro",
    price: 60,
    description: [
      "1000 responses/mo.",
      "Unlimited questions",
      "All templates",
      "Targeted gender and age can be selected for free",
      "Visualized data analytics",
    ],
    amount: 60,
    iconCount: 2,
  },
  {
    name: "Premium",
    price: 150,
    description: [
      "10,000 responses per month",
      "Unlimited questions",
      "Access to all templates",
      "Full criteria selection: Gender, Age, Education Level, Living Situation, Region, Marital Status, Employment Status, Income",
      "Visualized Data Analytics",
      "AI-powered Features",
      "Advanced Result Filtering",
    ],
    iconCount: 3,
    amount: 150,
    isActive: true,
  },
];
const BillingCard = ({ plan, isActive }) => {
  return (
    <div className={`billing_card ${isActive ? "active" : ""}`}>
      <div className="content">
        <div className="head">
          <div className="icon_wrap">
            {Array.from({ length: plan.iconCount }).map((_, index) => (
              <img key={index} src={billingDollar} alt="Icon" />
            ))}
          </div>
          {/* <span className="tag">save 5%</span> */}
        </div>
        <h4>{plan.price}</h4>
        <h5>{plan.name}</h5>
        <ul>
          {plan.description.map((desc, index) => (
            <li key={`plan-description-${index}`}>{desc}</li>
          ))}
        </ul>
      </div>
      <div className="button_wrap">
        <LoadingButton className="w-100">
          Buy for {plan.amount} SAR
        </LoadingButton>
      </div>
    </div>
  );
};
const PricingMode = () => {
  return (
    <>
      <div className="pricing_mode spacing">
        <div className="container">
          <div className="page_title">
            <h3>Pricing Made Easy</h3>
            {/* <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. 
            </p> */}
          </div>

          <div className="billing_card_wrap spacing">
            {plans.map((plan, index) => (
              <BillingCard key={index} plan={plan} isActive={plan.isActive} />
            ))}
          </div>
          <FAQS />
        </div>
      </div>
    </>
  );
};
export default PricingMode;
